import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

const selectRuleGroups = createSelector(selectUnderwriting, ({ ruleGroups }) => ruleGroups);

export const selectRuleGroupsList = createSelector(selectRuleGroups, Object.values);

export const selectRuleGroupListOptions = createSelector(selectRuleGroupsList, ruleGroups =>
  ruleGroups.map(({ name, id }) => ({ name, id })),
);

export const selectRuleGroupById = memoizeOne(id =>
  createSelector(selectRuleGroups, ruleGroups => ruleGroups[id] || {}),
);
